<?xml version="1.0" encoding="UTF-8"?>
<svg width="8px" height="4px" viewBox="0 0 8 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon id="Triangle" fill="#C7C7C7" transform="translate(4.000000, 2.000000) scale(1, -1) translate(-4.000000, -2.000000) " points="4 0 8 4 0 4"></polygon>
    </g>
</svg>